export const SummaryIcon = ({ customClassName = '' }: { customClassName?: string }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="38" viewBox="0 0 30 38" fill="none" className={customClassName}>
      <path
        d="M7.5 30.4H22.5V26.6H7.5V30.4ZM7.5 22.8H22.5V19H7.5V22.8ZM3.75 38C2.71875 38 1.83594 37.6279 1.10156 36.8838C0.367188 36.1396 0 35.245 0 34.2V3.8C0 2.755 0.367188 1.86042 1.10156 1.11625C1.83594 0.372083 2.71875 0 3.75 0H18.75L30 11.4V34.2C30 35.245 29.6328 36.1396 28.8984 36.8838C28.1641 37.6279 27.2812 38 26.25 38H3.75ZM16.875 13.3H26.25L16.875 3.8V13.3Z"
        fill="currentColor"
      />
    </svg>
  )
}
